import Vue from "vue"
import VueFormWizard from '../components/libs/vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)
